import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
interface SlideTitleProps {
  onContinue: () => void;
}
export function SlideTitle({
  onContinue
}: SlideTitleProps) {
  return <div className="h-full w-full flex flex-col items-center justify-center px-12 py-16 text-center relative" data-id="element-586">
      <div className="z-10 max-w-4xl w-full space-y-8" data-id="element-587">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="space-y-4" data-id="element-588">
          <h1 className="text-5xl md:text-7xl font-serif text-white" data-id="element-589">
            Strategic Focus: <br data-id="element-590" />
            <span className="text-teal-400" data-id="element-591">Legacy Brand Optimization</span>
          </h1>
          <p className="text-xl md:text-2xl text-white/70 font-medium max-w-2xl mx-auto mt-6" data-id="element-592">
            Unlocking significant value from the revenue tail through
            continuous, scalable optimization.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.5
      }} className="pt-12" data-id="element-593">
          <Button onClick={onContinue} className="px-8 py-4 text-lg" data-id="element-594">
            Lifecycle
          </Button>
        </motion.div>
      </div>
    </div>;
}